import type { ApiHook } from 'utils/request/useApi';

export function startExtension(
  extensionId: string,
  api: ApiHook,
): Promise<void> {
  return api.request({
    method: 'POST',
    url: `extensions/${extensionId}/start`,
  });
}
